import { atom } from "recoil";

export const allCollapsedAtom = atom<number>({
  key: 'collasped',
  default: 0,
});